import new_player_set_events from "@/components/new-player/modules/new_player_set_events";

export default async (context) => {
    let component = document.getElementById('player-component').children[0]
    let video = document.createElement('video')
    video.setAttribute('id', `player-component__video`)
    let source = document.createElement('source')
    source.setAttribute('type', context.videos[0].video ? 'video/mp4' : 'video/webm')
    video.setAttribute('muted', 'muted')
    video.setAttribute('playsinline', '');
    video.setAttribute('controlslist', 'nodownload');

    let new_url = await URL.createObjectURL(new Blob([context.videos[0].blob]));
    context.videos[0].new_url = new_url
    source.setAttribute('src', `${new_url}`)
    video.append(source)
    component.append(video)

    video.load()

    new_player_set_events(context, video)
    context.$emit('loadingComplete')
}